module.exports = __webpack_public_path__ + "assets/giphy-11.gif";